import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import withApiError, {
  ERROR_TYPE_REPORTING,
} from 'layers/errorHandling/apiError'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import { navigationEvent } from 'layers/navigation/store/operations'
import { operations as reportsOperations } from 'store/reportsManager'
// NOTE: licenseManager imports no longer needed in v4 sites flow
import { operations as loadingOperations } from 'store/loadingManager'
import {
  operations as ssapiOperations,
  selectors as ssapiSelectors,
} from 'store/ssapiManager'

import { getLicenseIdFromLicenseOptionText } from 'utils/productHelpers'

import SelaReport from './component'
import { LOADING_TEXT } from './constants'

export class SelaReportContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedLicense: {},
      selectedSelaReport: {},
    }
    this.checkToUpdateLoadingState = this.checkToUpdateLoadingState.bind(this)
  }

  componentDidMount() {
    const { fetchUserSites, sites } = this.props || {}

    this.checkToUpdateLoadingState()
    if (!Array.isArray(sites)) {
      if (typeof fetchUserSites === 'function') {
        fetchUserSites()
      }
    } else {
      this.setDefaultLicense()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isFetching: previousFetching } = prevProps
    const {
      isFetching,
      activeSelaSites,
      isLoadingApp,
      setAppNotLoadingState,
    } = this.props
    const { selectedLicense: previousLicense } = prevState
    const { selectedLicense } = this.state
    const doneFetchingLicense = previousFetching && !isFetching
    const doneLoading = doneFetchingLicense && isLoadingApp
    const licenseChanged = previousLicense?.id !== selectedLicense?.id

    if (activeSelaSites?.length > 0) {
      this.setDefaultLicense()
    }

    if (licenseChanged || doneFetchingLicense) {
      this.updateSelectedLicense()
    }

    this.checkToUpdateLoadingState()
    if (doneLoading) {
      setAppNotLoadingState()
    }
  }

  componentWillUnmount = async () => {
    const { isLoadingApp, setAppNotLoadingState } = this.props
    if (isLoadingApp) {
      setAppNotLoadingState()
    }
  }

  checkToUpdateLoadingState() {
    const {
      modules,
      activeSelaSites,
      setAppIsLoadingState,
      isLoadingApp,
      setAppNotLoadingState,
    } = this.props || {}

    const shouldLoad = activeSelaSites?.length === 0 || !modules

    if (shouldLoad && !isLoadingApp) {
      setAppIsLoadingState(LOADING_TEXT)
    }
    if (!shouldLoad && isLoadingApp) {
      setAppNotLoadingState()
    }
  }

  // TECH-DEBT: store selected license data in redux so other components can access the same data
  //            instead of having to drill it down from here
  setDefaultLicense() {
    const { selectedLicense } = this.state
    const { activeSelaSites, updateSelectedLicense } = this.props

    if (
      activeSelaSites?.length > 0 &&
      Object.entries(selectedLicense)?.length === 0
    ) {
      const defaultSite = activeSelaSites[0]
      const activeSelaLicense = defaultSite.netSuiteAssets.find(({ product }) =>
        product.programCodes.includes('ADL'),
      )
      updateSelectedLicense(activeSelaLicense.id)
      this.setState({
        selectedLicense: { ...activeSelaLicense, siteName: defaultSite?.name },
      })
    }
  }

  getBannerBody = () => {
    const {
      activeSelaSites,
      singleLicenseText,
      multipleLicenseText,
    } = this.props
    if (activeSelaSites?.length > 1) {
      return { type: 'banner-body-multiple-license', text: multipleLicenseText }
    }
    return { type: 'banner-body-single-license', text: singleLicenseText }
  }

  onLicenseChange = e => {
    const { value: licenseOptionText } = e || {}
    // TODO: Change option value to the licenseId so you don't have to parse the label text to get it
    const licenseId = getLicenseIdFromLicenseOptionText(licenseOptionText)
    const { activeSelaSites, updateSelectedLicense } = this.props
    const matchedSite = activeSelaSites.find(site =>
      site.netSuiteAssets.some(({ id }) => id.toString() === licenseId),
    )
    const matchedDigitalLicense = matchedSite?.netSuiteAssets?.find(
      ({ id }) => id.toString() === licenseId,
    )

    if (matchedDigitalLicense) {
      updateSelectedLicense(
        matchedDigitalLicense.id || matchedDigitalLicense.licenseId,
      )
      this.setState({
        selectedLicense: {
          ...matchedDigitalLicense,
          siteName: matchedSite?.name,
        },
      })
    }
  }

  updateSelectedLicense = () => {
    const { fetchReportsContentTrack, selaReports } = this.props
    const { selectedLicense } = this.state
    const { id } = selectedLicense

    if (!id) return
    console.log('selaReports', selaReports)

    if (selaReports && selaReports[id] && selaReports[id].content_tracks) {
      this.setState({ selectedSelaReport: selaReports[id] })
    } else {
      fetchReportsContentTrack(id)
    }
  }

  render() {
    const { selectedLicense, selectedSelaReport } = this.state
    const {
      activeSelaSites,
      displayTitle,
      emptyStateText,
      helpText,
      moduleCsvTooltip,
      modules,
      selectedContentTrack,
      selectedModuleId,
      staffProgressTooltip,
      unitCsvTooltip,
      updateSelectedContentTrack,
      updateSelectedModuleId,
      userTypeTooltip,
    } = this.props
    if (activeSelaSites?.length < 1 || !modules) {
      return null
    }

    return (
      <SelaReport
        activeSelaSites={activeSelaSites}
        bannerBody={this.getBannerBody()}
        bannerTitle={displayTitle}
        emptyStateText={emptyStateText}
        footerText={helpText}
        moduleCsvTooltip={moduleCsvTooltip}
        modules={modules}
        navigationEvent={navigationEvent}
        onLicenseChange={this.onLicenseChange}
        selaReport={selectedSelaReport}
        selectedContentTrack={selectedContentTrack}
        selectedLicense={selectedLicense}
        selectedModuleId={selectedModuleId}
        staffProgressTooltip={staffProgressTooltip}
        unitCsvTooltip={unitCsvTooltip}
        updateSelectedContentTrack={updateSelectedContentTrack}
        updateSelectedModuleId={updateSelectedModuleId}
        userTypeTooltip={userTypeTooltip}
      />
    )
  }
}

SelaReportContainer.propTypes = {
  activeSelaSites: PropTypes.array,
  deleteReportsData: PropTypes.func,
  displayTitle: PropTypes.string,
  emptyStateText: PropTypes.string,
  fetchReportsContentTrack: PropTypes.func.isRequired,
  helpText: PropTypes.string,
  isFetching: PropTypes.bool,
  isLoadingApp: PropTypes.bool,
  moduleCsvTooltip: PropTypes.string,
  modules: PropTypes.array,
  multipleLicenseText: PropTypes.string,
  selaReports: PropTypes.object,
  selectedContentTrack: PropTypes.string,
  selectedModuleId: PropTypes.string,
  setAppNotLoadingState: PropTypes.func,
  singleLicenseText: PropTypes.string,
  staffProgressTooltip: PropTypes.string,
  unitCsvTooltip: PropTypes.string,
  updateSelectedContentTrack: PropTypes.func,
  updateSelectedLicense: PropTypes.func.isRequired,
  updateSelectedModuleId: PropTypes.func,
  userTypeTooltip: PropTypes.string,
}

export const mapper = (entry, state) => {
  const { reportsManager } = state || {}
  const sites = ssapiSelectors.selectUserSites(state)
  const { sela_report: selaReports } = reportsManager?.reports || {}
  const currentProduct = sites?.filter(({ netSuiteAssets }) =>
    netSuiteAssets.find(({ id }) => id === reportsManager?.selectedLicense),
  )?.[0]
  const productName = currentProduct?.netSuiteAssets?.find(
    ({ id }) => id === reportsManager?.selectedLicense,
  )?.product?.description
  const {
    displayTitle,
    emptyStateText,
    helpText,
    multipleLicense,
    programRef,
    programRef2,
    singleLicense,
    tooltips,
  } = entry || {}

  const programData =
    (productName === 'SELA Field Test' ? programRef2 : programRef) || {}
  const { productSubsections } = programData || {}
  const tooltipsCopy = tooltips?.map(t => t.text)
  const [
    userTypeTooltip,
    moduleCsvTooltip,
    staffProgressTooltip,
    unitCsvTooltip,
  ] = tooltipsCopy || []

  return {
    activeSelaSites: sites?.filter(({ capabilities }) =>
      capabilities.find(capability => capability.name === 'ADL'),
    ),
    displayTitle,
    emptyStateText,
    helpText,
    moduleCsvTooltip,
    modules: productSubsections,
    multipleLicenseText: multipleLicense,
    selaReports,
    singleLicenseText: singleLicense,
    sites,
    staffProgressTooltip,
    unitCsvTooltip,
    userTypeTooltip,
  }
}

const options = {
  entryId: '4evS2d4N8ZmLoNf6IJAzE8',
  include: 4,
  mapper,
  spread: true,
}

const mapStateToProps = ({ reportsManager, loadingManager }) => ({
  selaReports: reportsManager?.reports,
  isFetching: reportsManager?.isFetching,
  selectedContentTrack: reportsManager?.selectedContentTrack,
  selectedModuleId: reportsManager?.selectedModuleId,
  isLoadingApp: loadingManager?.isLoading,
})

const mapDispatchToProps = {
  deleteReportsData: reportsOperations.deleteReportsData,
  fetchReportsContentTrack: reportsOperations.fetchReportsContentTrack,
  navigationEvent,
  fetchUserSites: ssapiOperations.fetchUserSites,
  updateSelectedContentTrack: reportsOperations.updateSelectedContentTrack,
  updateSelectedLicense: reportsOperations.updateSelectedLicense,
  updateSelectedModuleId: reportsOperations.updateSelectedModuleId,
  setAppIsLoadingState: loadingOperations.setIsLoadingState,
  setAppNotLoadingState: loadingOperations.setNotLoadingState,
}

export default ContentEntryDataGetter(
  withApiError(SelaReportContainer, [ERROR_TYPE_REPORTING]),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
